import classNames from "classnames";
import React from "react";

import "./toggleSwitch.scss";

export interface State {
  switchedOn: boolean;
}

export interface Props {
  onToggle?: (switchedOn: boolean) => void;
  switchedOn?: boolean;
  onLabel?: string;
  offLabel?: string;
  disabled?: boolean;
}

export class ToggleSwitch extends React.Component<Props, State>{
  constructor(props: Props) {
    super(props);
    this.state = { switchedOn: props.switchedOn || false };
  }

  private toggleSwitch = (e: React.SyntheticEvent<any>) => {
    e.stopPropagation();

    if (this.props.disabled) {
      return;
    }

    const newState = !this.state.switchedOn;
    this.setState({ switchedOn: newState }, () => {
      if (this.props.onToggle) {
        this.props.onToggle(newState);
      }
    });
  }

  public componentWillMount() {
    this.setState({ switchedOn: this.props.switchedOn });
  }

  public componentWillReceiveProps(newProps: Props) {
    this.setState({ switchedOn: newProps.switchedOn });
  }

  public render() {
    const classes = classNames("toggle-switch", { "toggled-on": this.state.switchedOn, "disabled": this.props.disabled } );
    const title = `${this.state.switchedOn ? (this.props.onLabel || "ON") : (this.props.offLabel || "OFF")}`;
    return (
      <div className={classes} onClick={(e) => this.toggleSwitch(e)} title={title} />
    );
  }
}
